import { Box, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LayoutTable from "./layout/Table";
import Search from "../../../shared/components/Search";
import { FilterIconSvg } from "../../../assets/icons/FilterIconSvg";
import { ButtonPrimary } from "../../../shared/components/button/Buttons";
import { useGlobalContext } from "../../../App";
import AddFeaturedProjectPopup from "./AddFeaturedProjectPopup";
import EditFeaturedProjectPopup from "./EditFeaturedProjectPopup";

type Props = {};

export interface ActionMenuProps {
  title: string;
  action: () => void;
  actionTitle: string;
}

const tableRef = React.createRef<any>();

const FeaturedProjectsList = (props: Props) => {
  const { studioContentData } = useGlobalContext();

  const columnItems = [
    { id: "Title", label: "Title" },
    { id: "Description", label: "Description" },
    { id: "Link", label: "Link" },
    { id: "Date Edited", label: "Date Edited" },
  ];

  // TabPanel handling states and functions
  const [value, setValue] = useState(0);
  const [isActiveAddProjectPopup, setIsActiveAddProjectPopup] =
    useState<boolean>(false);

  const [isEditDialogVisible, setIsEditDialogVisible] =
    useState<boolean>(false);

  // current page and rows per page handling states and functions
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [search, setSearch] = useState("");
  // all data ( if fetch all in one go )
  const [allProjects, setAllProjects] = useState(
    studioContentData?.projects || []
  );
  const [featuredProjectsLoading, setFeaturedProjectsLoading] = useState(false);
  const [featuredProjectsList, setFeaturedProjectsList] = useState<any>(
    studioContentData?.projects || []
  );

  // console.log("studioContentData ", studioContentData);

  // handle search
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    // Option 1: API call
    // api call here

    // Option 2: Local filtering
    if (value.trim() === "") {
      setFeaturedProjectsList(allProjects);
    } else {
      const filtered = allProjects.filter((item: any) =>
        item.title.toLowerCase().includes(value.toLowerCase())
      );
      setFeaturedProjectsList(filtered);
    }

    setPage(0); // page reset
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    // api call here
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    tableRef.current && tableRef.current.scrollIntoView();
    setRowsPerPage(+event.target.value);
    setPage(0);
    // api call here
  };

  const handleCloseAddProjectPopup = () => {
    setIsActiveAddProjectPopup(false);
  };
  const handleCloseEditProjectPopup = () => {
    setIsEditDialogVisible(false);
  };

  useEffect(() => {}, [featuredProjectsList]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingTop: "32px",
          paddingBottom: "12px",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: "15px",
            right: "98px",
            zIndex: 10000,
          }}
          display="flex"
          alignItems="center"
          justifySelf="flex-end"
        >
          <ButtonPrimary
            sx={{
              height: "45px !important",
              border: "14px !important",
              // width: "112px",
              width: "auto",
            }}
            onClick={() => setIsActiveAddProjectPopup(true)}
            LabelStyle={{ fontSize: "18px !important" }}
            label="Add Project(s)"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            width: "85%",
            mb: "21px",
            gap: "12px",
          }}
        >
          <Box
            // onKeyDown={handleKeyDown}
            sx={{ display: "flex", height: "52px" }}
          >
            <Search
              searchFormStyles={{
                minHeight: "22px",
              }}
              style={{
                minHeight: "52px",
                color: "white",
              }}
              icon={true}
              placeholder="Search by name"
              value={search}
              onChange={handleSearchChange}
            />
          </Box>

          <Box
            onClick={() => {}}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "52px",
              height: "52px",
              borderRadius: "14px",
              bgcolor: "#141414",
              boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
              cursor: "pointer",
            }}
          >
            <FilterIconSvg />
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            overflowY: "scroll",
            // overflowX: "scroll",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            scrollbarWidth: "none",
          }}
        >
          <TabPanel value={value} index={0}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                // overflowX: "scroll",
              }}
            >
              <Box
                sx={{
                  width: "85%",
                  //   paddingBottom: activeSelectedMenu ? "70px" : "0px",
                  height: "auto",
                  // overflowX: "scroll",
                }}
              >
                <LayoutTable
                  loading={featuredProjectsLoading}
                  // rows={featuredProjectsList}
                  rows={featuredProjectsList}
                  columns={columnItems}
                  setIsEditDialogVisible={setIsEditDialogVisible}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <TablePagination
                    labelRowsPerPage="Showing"
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      style: {
                        fontWeight: "700",
                      },
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            backgroundColor: "#3D3D3D",
                            "& .MuiMenuItem-root": {
                              color: "#ffff",
                              "&:hover": {
                                backgroundColor: "#555555",
                              },
                            },
                          },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiTablePagination-selectLabel": {
                        fontWeight: "700",
                        color: "rgba(255, 255, 255, 0.24)",
                        marginRight: "5px",
                      },
                      "& .MuiTablePagination-displayedRows": {
                        color: "rgba(255, 255, 255, 0.24)",
                        fontWeight: "600",
                      },
                      "& .MuiButtonBase-root": {
                        boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
                        cursor: "pointer !important",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                      },
                      "& .MuiTablePagination-actions": {
                        display: "flex",
                        gap: "12px !important",
                        flex: 1,
                        justifyContent: "flex-end",
                      },
                      "&.MuiTablePagination-root": {
                        width: "100%",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      },
                      "& .MuiTablePagination-spacer": {
                        flex: 0,
                        display: "none",
                      },
                      "& .MuiTablePagination-toolbar": {
                        flex: 1,
                        display: "flex",
                        paddingLeft: 0,
                      },
                      "& .MuiTablePagination-select": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)",
                        borderRadius: "4px",
                        padding: "6px 12px",
                      },
                      "& .MuiInputBase-input": {
                        color: "#ffff",
                      },
                      // To hide the rows per page dropdown
                      "& .MuiInputBase-root": {
                        // display: "none",
                      },
                    }}
                    rowsPerPageOptions={[25, 50, 100]}
                    component="div"
                    count={featuredProjectsList?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              </Box>
            </Box>
          </TabPanel>
        </Box>
      </Box>
      {isActiveAddProjectPopup && (
        <AddFeaturedProjectPopup
          activeDialog={isActiveAddProjectPopup}
          handleDialog={handleCloseAddProjectPopup}
          handleRefreshData={() => {}}
        />
      )}
      {isEditDialogVisible && (
        <EditFeaturedProjectPopup
          activeDialog={isEditDialogVisible}
          handleDialog={handleCloseEditProjectPopup}
          handleRefreshData={() => {}}
          activeDialogData={isEditDialogVisible}
        />
      )}
    </>
  );
};

export default FeaturedProjectsList;

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{ width: "100%" }}
      className="HideScrollbar"
      // sx={{ maxHeight: SECTION_MIN_HEIGHT }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ flex: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}
